"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentDevice = void 0;
const react_1 = require("react");
const features_1 = require("../../features");
const useCurrentDevice = (deviceMeasure) => {
    const [currentDevice, setCurrentDevice] = (0, react_1.useState)(features_1.Device.DESKTOP);
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            const deviceChecker = new features_1.DeviceChecker(deviceMeasure);
            setCurrentDevice(deviceChecker.getCurrentDeviceByWidth());
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return currentDevice;
};
exports.useCurrentDevice = useCurrentDevice;
//# sourceMappingURL=useCurrentDevice.js.map